import classnames from 'clsx';
import { FormattedMessage } from 'react-intl';

import { CollapsibleListSection } from 'ui-components/components/collapsible-list/collapsible-list-section';
import { CollapsibleListSectionContent } from 'ui-components/components/collapsible-list/collapsible-list-section-content';
import { CollapsibleListSectionHeader } from 'ui-components/components/collapsible-list/collapsible-list-section-header';
import { Pill } from 'ui-components/components/pill';
import { noop } from 'ui-components/default-props/noop';

import { messages } from './messages';
import { TagsSummary } from './tags-summary';
import style from './tags.module.less';
import { emptyArray } from 'ui-components/default-props/empty';
import TagDropdown from '../../../tag-dropdown';

/**
 * @typedef {import('../../../../prop-types/tag').TagPropType} Tag
 */

const onTagToggled = (selectedTags, addTag, removeTag, tag, fulfillmentPlanId) => {
  if (selectedTags.indexOf(tag) === -1) {
    addTag(fulfillmentPlanId, tag.tagId);
    return;
  }
  removeTag(fulfillmentPlanId, tag.tagId);
};

const summaryTags = (selectedTags, widgetIsOpen) => {
  if (widgetIsOpen || !selectedTags || selectedTags.length === 0) {
    return;
  }

  return <TagsSummary pillClassName={style.pill} pillWrapperClassName={style['pill-wrapper']} selectedTags={selectedTags} />;
};

/**
 * @deprecated
 * @param {object} props
 * @param {boolean} [props.open]
 * @param {(open: boolean) => void} [props.onClick]
 * @param {Tag[]} props.tags
 * @param {Tag[]} [props.selectedTags]
 * @param {(fulfillmentPlanId: string, tagId: string) => void} props.addTag
 * @param {(fulfillmentPlanId: string, tagId: string) => void} props.removeTag
 * @param {string} [props.currentFulfillmentPlanId]
 * @param {object} [props.dragHandleProps]
 * @returns {JSX.Element}
 */
const Tags = ({
  open = false,
  onClick = noop,
  tags,
  selectedTags = emptyArray,
  addTag,
  removeTag,
  currentFulfillmentPlanId = '',
  dragHandleProps,
}) => {
  return (
    <CollapsibleListSection open={open}>
      <CollapsibleListSectionHeader
        dragHandleProps={dragHandleProps}
        onClick={() => onClick(open)}
        summaryData={summaryTags(selectedTags, open)}
        theme='white'
      >
        <FormattedMessage {...messages.tags} />
      </CollapsibleListSectionHeader>
      <CollapsibleListSectionContent>
        <div className={style['orders-drawer-tags']}>
          {selectedTags.length !== 0 && (
            <div className={style.tags}>
              {selectedTags.map((tag, index) => (
                <Pill
                  key={index}
                  className={style.pill}
                  color={tag.hexColor}
                  label={tag.name}
                  onRemove={() => onTagToggled(selectedTags, addTag, removeTag, tag, currentFulfillmentPlanId)}
                  theme='tag'
                />
              ))}
            </div>
          )}
          <div
            className={classnames(style['add-tag-row'], {
              [style['no-tag-row']]: selectedTags.length === 0,
            })}
          >
            {selectedTags.length === 0 && (
              <div className={style['no-tag-message']}>
                <FormattedMessage {...messages.noTags} />
              </div>
            )}
            <TagDropdown
              className={style['tag-dropdown']}
              menuPosition='bottom-right'
              onTagToggled={(tag) => onTagToggled(selectedTags, addTag, removeTag, tag, currentFulfillmentPlanId)}
              selectedTags={selectedTags}
              tags={tags}
            />
          </div>
        </div>
      </CollapsibleListSectionContent>
    </CollapsibleListSection>
  );
};

export default Tags;
